import { render, staticRenderFns } from "./Personale.vue?vue&type=template&id=241dee1e&"
import script from "./Personale.vue?vue&type=script&lang=js&"
export * from "./Personale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports